import axios, { AxiosRequestConfig } from 'axios';

// API Axios Get Call.
export const getAPICall = (url: string, config = {}) => {
  return axios.get(url, config).catch(function (error) {
    // handle error
    console.log(error);
  });
};

// API Axios Post Call.
export const postAPICall = (url: string, data: Record<string, any> | null, config = {}) => {
  return axios.post(url, data, config).catch(function (error) {
    console.log(error);
    throw error;
  });
};

// API Axios Put Call.
export const putAPICall = (url: string, data: any) => {
  return axios.put(url, data);
};

// API Axios Delete Call.
export const deleteAPICall = (url: string, config: AxiosRequestConfig = {}) => {
  return axios.delete(url, config);
};

// API Axios Get Async Call.
export const getAPIAsyncCall = async (url: string) => {
  return await axios.get(url);
};

// API Axios Post Async Call.
export const postAPIAsyncCall = async (url: string, data: any) => {
  return await axios.post(url, data);
};

export const uploadFile = (url: string, data: any, header: AxiosRequestConfig | undefined) => {
  return axios.post(url, data, header);
};

// API Axios Download Async Call.
export const downloadAsyncCall = async (url: string, resType: any) => {
  return await axios.get(url, {
    responseType: resType,
  });
};
